import { render, staticRenderFns } from "./TouristsForm.vue?vue&type=template&id=272ee268&scoped=true&"
import script from "./TouristsForm.vue?vue&type=script&lang=js&"
export * from "./TouristsForm.vue?vue&type=script&lang=js&"
import style0 from "./TouristsForm.vue?vue&type=style&index=0&id=272ee268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ee268",
  null
  
)

export default component.exports